module.exports = __webpack_public_path__ + "img/babyComposer.9b1f967b.png";